<template>

  <div class="iris needResize" :class="{'fullscreen': fullscreen}">
    <Info @fullscreen="onFullScreen" title="iris.title" text="iris.info" ></Info>
    <div class="title">
      <h3>{{$t('iris.title')}}</h3>
    </div>
    <div v-if="display" class="main-content-iris-rent">
      <!--chartist ref="chart" :data="chartData" :options="chartOptions" type="Bar" :event-handlers="eventHandlers"></chartist-->
      <GChart
              type="BarChart"
              :data="ownerChartData"
              :options="widgets.owner.chartOptions"
      />
    </div>
    <br />
    <div v-if="display" class="main-content-iris-csp">
      <GChart
              type="BarChart"
              :data="cspChartData"
              :options="widgets.csp.chartOptions"
      />
    </div>
    <br />
    <div v-if="display" class="main-content-iris-families">
      <GChart
              type="BarChart"
              :data="familiesChartData"
              :options="widgets.families.chartOptions"
      />
    </div>
    <br />
    <div v-if="display" class="main-content-iris-vehicles">
      <GChart
              type="BarChart"
              :data="vehiclesChartData"
              :options="widgets.vehicles.chartOptions"
      />
    </div>
    <br />
    <div v-if="display" class="main-content-iris-income">
      <GChart
              type="BarChart"
              :data="incomeChartData"
              :options="widgets.income.chartOptions"
      />
    </div>
    <div v-else>
      <br />
      No demographic data for this business unit (France only)
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'

  export default {
    name: 'IRIS',
    components: {
      Info
    },
    props: {
      result: Object,
      search: Object,
      nbOfColumns: Number
    },
    watch: {
      result(new_value, old_value) {
        this.refresh()
      },
      nbOfColumns() {
        this.refresh(true)
      }
    },
    mounted() {
      let iris = document.getElementsByClassName('iris');
      if (iris && iris[0]) {
        //this.widgets.owner.chartOptions.height = 150
        let width = iris[0].clientWidth;
        this.widgets.owner.chartOptions.width = width
        //this.widgets.csp.chartOptions.height = 400
        this.widgets.csp.chartOptions.width = width
        this.widgets.families.chartOptions.width = width
        this.widgets.vehicles.chartOptions.width = width
        this.widgets.income.chartOptions.width = width
      }
    },
    data () {
      let color1 = '#3f51b5';
      let color2 = '#43425d';

      return {
        fullscreen: false,

        // Array will be automatically processed with visualization.arrayToDataTable function
        widgets: {
          owner: {
            chartOptions: {
              colors: [color1, color2],
              width: 0,
              height: 200,
              legend: 'top',
              title: 'Propriétaires vs Locataires (%)',
              hAxis: {
                minValue: 0
              }
            },
            myWidth: 0,
            myHeight: 0
          },
          csp: {
            chartOptions: {
              colors: [color1, color2],
              width: 0,
              height: 400,
              legend: 'top',
              title: 'Catégories socio prof. (%)',
              hAxis: {
                minValue: 0
              }
            },
            myWidth: 0,
            myHeight: 0
          },
          families: {
            chartOptions: {
              colors: [color1, color2],
              width: 0,
              height: 400,
              legend: 'top',
              title: 'Composition du foyer (%)',
              hAxis: {
                minValue: 0
              }
            },
            myWidth: 0,
            myHeight: 0
          },
          vehicles: {
            chartOptions: {
              colors: [color1, color2],
              width: 0,
              height: 300,
              legend: 'top',
              title: 'Nombre de véhicule(s) dans le ménage (%)',
              hAxis: {
                minValue: 0
              }
            },
            myWidth: 0,
            myHeight: 0
          },
          income: {
            chartOptions: {
              colors: [color1, color2],
              width: 0,
              height: 200,
              legend: 'top',
              title: 'Revenu moyen des ménages (€)',
              hAxis: {
                minValue: 0
              }
            },
            myWidth: 0,
            myHeight: 0
          }
        },
        eventHandlers: []
      }
    },
    computed: {
      france: function() {
        return 'Population Française'
      },
      customers: function() {
        return 'Clients de l\'enseigne'
      },
      display: function(){
        return this.search.query.businessUnit === 'NORFRA' || this.search.query.businessUnit === 'MIDFRA'
      },
      ownerChartData(){
        if (this.result && this.result.aggregations && this.result.aggregations.iris) {
          let aggregations = this.result.aggregations
          if (aggregations.iris.rent && aggregations.iris.owner) {
            return [
              ['Population', this.france, this.customers],
              ['Rent', 40, aggregations.iris.rent.value * 100.0],
              ['Owner', 60, aggregations.iris.owner.value * 100.0]]
          }
        }
        return [['Population', this.france, this.customers],
          ['Rent', 0, 0],
          ['Owner', 0, 0]]
      },
      cspChartData(){
        if (this.result && this.result.aggregations && this.result.aggregations.iris) {
          let aggregations = this.result.aggregations
          if (aggregations.iris.job_farmer && aggregations.iris.job_artis_entrepr_shop && aggregations.iris.job_executive_sup && aggregations.iris.job_intermediate_job && aggregations.iris.job_employee && aggregations.iris.job_workers) {
            return [
              ['Population', this.france, this.customers],
              ['Agriculteurs', 0.0117477829445810940734197295679036642486 * 100.0, aggregations.iris.job_farmer.value * 100.0],
              ['Artisans/Com/Chef d\'Ent', 0.0515064688632216886835581719350562213988 * 100.0, aggregations.iris.job_artis_entrepr_shop.value * 100.0],
              ['Cadres et Prof. Int Sup.', 0.1520783967992832687387018377073715991826 * 100.0, aggregations.iris.job_executive_sup.value * 100.0],
              ['Prof. intermédiaires', 0.2419036305173254141541088683880250861178 * 100.0, aggregations.iris.job_intermediate_job.value * 100.0],
              ['Employés', 0.2886390082167048966936284721791643072303 * 100.0, aggregations.iris.job_employee.value * 100.0],
              ['Ouvriers', 0.2280585318371992687475384090403149094016 * 100.0, aggregations.iris.job_workers.value * 100.0],
            ]
          }
        }
        return []
      },
      familiesChartData(){
        if (this.result && this.result.aggregations && this.result.aggregations.iris) {
          let aggregations = this.result.aggregations
          if (aggregations.iris.fam_0_child && aggregations.iris.fam_1_child && aggregations.iris.fam_2_child && aggregations.iris.fam_3_child && aggregations.iris.fam_4_child) {
            return [
              ['Population', this.france, this.customers],
              ['Sans enfant', 0.4674735113268735964441490473495416101405 * 100.0, aggregations.iris.fam_0_child.value * 100.0],
              ['1 enfant', 0.2225011481825328353216776961624468985302 * 100.0, aggregations.iris.fam_1_child.value * 100.0],
              ['2 enfants', 0.1976229273753045917478730131562841856099 * 100.0, aggregations.iris.fam_2_child.value * 100.0],
              ['3 enfants', 0.0685533626805461919896750028904935688616 * 100.0, aggregations.iris.fam_3_child.value * 100.0],
              ['4 enfants et +', 0.020862653859325426306683244008570035 * 100.0, aggregations.iris.fam_4_child.value * 100.0],
            ]
          }
        }
        return []
      },
      vehiclesChartData(){
        if (this.result && this.result.aggregations && this.result.aggregations.iris) {
          let aggregations = this.result.aggregations
          if (aggregations.iris.veh_0 && aggregations.iris.veh_1 && aggregations.iris.veh_2) {
            return [
              ['Population', this.france, this.customers],
              ['Sans véhicule', 18.13248130493651514463587257602981351503, aggregations.iris.veh_0.value * 100.0],
              ['1 véhicule', 45.95003659930785092293643443813884768123, aggregations.iris.veh_1.value * 100.0],
              ['2 véhicules et +', 34.42131954027677216231888360105420808692, aggregations.iris.veh_2.value * 100.0]
            ]
          }
        }
        return []
      },
      incomeChartData(){
        if (this.result && this.result.aggregations && this.result.aggregations.iris) {
          let aggregations = this.result.aggregations
          if (aggregations.iris.average_income) {
            return [
              ['Population', this.france, this.customers],
              ['Revenu moyen annuel', 24146 , aggregations.iris.average_income.value],
            ]
          }
        }
        return []
      }
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
        this.refresh()
      },
      refresh (forceRefresh) {

        let owner = this.widgets.owner;
        let csp = this.widgets.csp;
        let families = this.widgets.families
        let vehicles = this.widgets.vehicles;
        let income = this.widgets.income;

        let iris = document.getElementsByClassName('iris');
        if(iris && iris[0] && (owner.myWidth == 0 || forceRefresh === true)) {
          //owner.myHeight = 200
          owner.myWidth = iris[0].clientWidth
        }

        if(iris && iris[0] && (csp.myWidth == 0 || forceRefresh === true)) {
          //csp.myHeight = 500
          csp.myWidth = iris[0].clientWidth
        }

        if(iris && iris[0] && (families.myWidth == 0 || forceRefresh === true)) {
          //csp.myHeight = 500
          families.myWidth = iris[0].clientWidth
        }

        if(iris && iris[0] && (vehicles.myWidth == 0 || forceRefresh === true)) {
          //csp.myHeight = 500
          vehicles.myWidth = iris[0].clientWidth
        }

        if(iris && iris[0] && (income.myWidth == 0 || forceRefresh === true)) {
          //csp.myHeight = 500
          income.myWidth = iris[0].clientWidth
        }

        if (this.fullscreen) {
          owner.chartOptions.width = screen.width * 0.7
          //owner.chartOptions.height = screen.height * 0.7
          csp.chartOptions.width = screen.width * 0.7
          families.chartOptions.width = screen.width * 0.7
          income.chartOptions.width = screen.width * 0.7
          vehicles.chartOptions.width = screen.width * 0.7
          //csp.chartOptions.height = screen.height * 0.7
        } else {
          owner.chartOptions.width = this.widgets.owner.myWidth
          //owner.chartOptions.height = this.widgets.owner.myHeight
          csp.chartOptions.width = this.widgets.csp.myWidth
          families.chartOptions.width = this.widgets.families.myWidth
          //csp.chartOptions.height = this.widgets.csp.myHeight
          vehicles.chartOptions.width = this.widgets.vehicles.myWidth
          income.chartOptions.width = this.widgets.income.myWidth
        }
      }
    },
    created() {
      let that = this
      this.eventHandlers = [{event:'created', fn() {that.$emit("refreshedChart")}}]
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/iris.sass"
</style>
